export enum DimensionLockType {
    None,
    Value,
    All,
}